import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/shin.png'


const _hoisted_1 = { href: "https://github.com/mslotwinski-dev/Shin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          draggable: "false"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }),
    _createElementVNode("a", _hoisted_1, [
      _createVNode(_component_ic, { icon: ['fab', 'github'] })
    ])
  ]))
}